// Cal State Fullerton's undergraduate majors (lane 2, #2745). Read on 2026-10-01 from
// the official 2026-2027 University Catalog's Degree Programs page
// (catalog.fullerton.edu, catoid=101; read in a headless browser behind its bot
// check). The catalog lists each concentration as its own line; here each major is
// kept once with its degree, concentrations folded in. Integrated B.S. + M.S. programs
// and the online degree-completion programs (not open to first-year applicants) are
// left out.
const majors = {
    "slug": "california-state-university-fullerton",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Cal State Fullerton's official 2026-2027 University Catalog, with the degree it leads to. Concentrations are folded into their major; graduate programs and online degree-completion programs are left out.",
    "groups": [
        {
            "name": "Bachelor's degrees",
            "source": {
                "label": "CSUF 2026-2027 University Catalog, Degree Programs",
                "url": "https://catalog.fullerton.edu/content.php?catoid=101&navoid=15150"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Science",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Child and Adolescent Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Cinema and Television Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communications",
                    "degree": "B.A."
                },
                {
                    "name": "Communicative Disorders",
                    "degree": "B.S."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "Earth Science",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Services",
                    "degree": "B.S."
                },
                {
                    "name": "International Business",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Public Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Learning",
                    "degree": "B.A."
                },
                {
                    "name": "Women and Gender Studies",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
